module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("UJjQG"))).then(() => module.bundle.root('hEqeo'));